import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO_DATA = {

  '/': {
    title: 'Centro di Riabilitazione e Performance a Verona | MCARE',
    description:
      'MCARE è un centro di riabilitazione situato a Verona e Sona. Offriamo trattamenti personalizzati per recupero post-infortunio, post-chirurgico, e gestione del dolore cronico. Prenota ora una visita!',
    image: "https://mcarefisio.it/assets/logo/ogMCare-2.jpg"
  },
  '/staff/': {
    title: 'Chi siamo | MCARE',
    description:
      'Conosci il nostro team di professioni di MCare, al tuo fianco per raggiungere i tuoi obiettivi di performance.',
    image: "https://mcarefisio.it/assets/logo/spalla.jpg"
  },

  '/fisioterapia/': {
    title: 'Fisioterapia | MCARE',
    description:
      'Scopri le nostre aree di intervento per rimetterti in gioco e tornare finalmente al tuo livello di performance desiderato!',
    image: "https://mcarefisio.it/assets/logo/fisioterapia.jpg"
  },

  '/formazione/': {
    title: 'Formazione | MCARE',
    description:
      "In Mcare la formazione è essenziale, perché vogliamo offrirti le cure migliori e all'avanguardia. Scopri di più!",
    image: "https://mcarefisio.it/assets/logo/formazione.jpg"
  },

  '/tecnologie/': {
    title: 'Tecnologia | MCARE',
    description:
      'Sfruttiamo le tecnologie più avanzate per aiutarti nel percorso di rimessa in campo. Scoprile ora!',
    image: "https://mcarefisio.it/assets/logo/the-procedure-of-myo.jpg"
  },

  '/servizi/': {
    title: 'Servizi | MCARE',
    description:
      'Una sfida non solo fisica, ma anche mentale: con Mcare ti diamo il supporto psicologico di cui hai bisogno. Scopri come!',
    image: "https://mcarefisio.it/assets/logo/player.jpg"
  },
  '/privacypolicy/': {
    title: 'Privacy Policy | MCARE',
    description:
      'Leggi la privacy policy di Mcare.',
    image: "https://mcarefisio.it/assets/logo/ogMCare-2.jpg"
  },
  '/sport-performance/': {
    title: 'Torna alla tua Performance | MCARE',
    description:
      'In MCare diamo nuova vita al tuo movimento per farti tornare alla tua performance desiderata. Ritorna a competere, inizia ora!',
    keywords: 'ritorno alla performance, performance, riabilitazione, recupero sportivo, competere, sport, movimento, mcare, mcare fisio, mcare fisio sport clinic',
    image: "https://mcarefisio.it/assets/landing/landingFisio/ritorno-alla-performance.jpg"
  },
  '/fisio-sport/': {
    title: 'Torna a muoverti come vuoi | MCARE',
    description:
      'Con Mcare torni a muoverti come hai sempre fatto attraverso un percorso di fisioterapia dedicato. Scoprilo ora!',
    keywords: 'mcare, mcare verona, mcare sona, fisioterapia, tornare al movimento, movimento, riabilitazione, metodo scientifico, mcare fisio sportclinic',
    image: "https://mcarefisio.it/assets/landing/landingFisio/torna_a_muoverti_come_vuoi.jpg"
  },
};

function Seo() {
  const location = useLocation();

  const pathname = location.pathname.endsWith('/')
    ? location.pathname
    : `${location.pathname}/`;

  const currentSeo = SEO_DATA[pathname] || SEO_DATA['/'];

  const canonicalUrl = `https://mcarefisio.it${pathname}`;

  return (
    <Helmet>
      <title>{currentSeo.title}</title>

      <meta
        name="description"
        content={currentSeo.description}
      />
      {currentSeo.keywords && (
        <meta name="keywords" content={currentSeo.keywords} />
      )}
      <meta property="og:title" content={currentSeo.title} />
      <meta property="og:description" content={currentSeo.description} />
      <meta property="og:image" content={currentSeo.image} />

      <link
        rel="canonical"
        href={canonicalUrl}
      />
    </Helmet>
  );
}

export default Seo;